module.exports = __webpack_public_path__ + "static/media/splats_top.0bcfec72.png";